import { useContext, useState, useEffect } from "react";
import { PhoneInput } from "react-international-phone";
import AuthContext from "../../../context/auth/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import useTranslator from "../../../hooks/useTranslator";
import { toast } from "../../../helper/common";

const EditLandLord = () => {
  const { _t } = useTranslator();

  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { user, updateProfile } = authContext;
  const { workspaceId } = useParams();
  const [phoneNumber, setPhoneNumber] = useState("");

  const [LandlordProfile, setLandlordProfile] = useState({
    fname_companyName: "",
    lname: "",
    cif_dni_nie: "",
    phone: "",
    linkedin_profile: "",
    email: "",
    type: "landlord",
    is_edit: true,
  });

  const onChangeLandlord = (e) => {
    setLandlordProfile({ ...LandlordProfile, [e.target.name]: e.target.value });
  };

  const onPhoneChange = (value) => {
    const phoneNumberWithoutPlus = value?.replace("+", "") || "";
    setPhoneNumber(phoneNumberWithoutPlus);
    setLandlordProfile({ ...LandlordProfile, phone: phoneNumberWithoutPlus });
  };

  async function isValidEmail(email) {
    // Regular expression for basic email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailPattern.test(email);
  }
  const onSubmitLandlord = async (e) => {
    e.preventDefault();
    const checkemail = await isValidEmail(LandlordProfile?.email);
    if (!checkemail) {
      toast.error(_t("Please enter valid email format"));
      return;
    }
    LandlordProfile.role = "landlord";
    LandlordProfile.is_edit = true;
    updateProfile(user?._id, LandlordProfile);
    navigate(`/${workspaceId}/landlord-profile`);
  };

  const closeButton = () => {
    navigate(`/${workspaceId}/landlord-profile`);
  };

  useEffect(() => {
    setLandlordProfile(user);
  }, []);

  useEffect(() => {
    setPhoneNumber(LandlordProfile?.phone || "");
  }, [LandlordProfile]);

  return (
    <>
      <div className="tabs-box-pattern">
        <div className="tabs-item d-block">
          <form onSubmit={onSubmitLandlord}>
            <div className="row">
              <div className="col-12">
                <h3 className="Property">{}</h3>
              </div>

              <div className="col-sm-6 col-12">
                <div className="info-wapper">
                  <label>{_t("firstName")}</label>
                  <input
                    type="text"
                    className="custom-input"
                    placeholder="Natash"
                    name="fname_companyName"
                    value={LandlordProfile?.fname_companyName || ""}
                    onChange={onChangeLandlord}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="info-wapper">
                  <label>{_t("phoneNumber")}</label>
                  <PhoneInput
                    className="custom-input phone_input_info"
                    international
                    defaultCountry={"es"}
                    value={phoneNumber}
                    onChange={onPhoneChange}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="info-wapper">
                  <label>{_t("lastName")}</label>
                  <input
                    type="text"
                    className="custom-input"
                    placeholder={_t("enterLastName")}
                    name="lname"
                    onChange={onChangeLandlord}
                    value={LandlordProfile?.lname || ""}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="info-wapper">
                  <label>{_t("linkedInProfile")}</label>
                  <input
                    type="text"
                    className="custom-input"
                    placeholder={_t("enterLinkedInProfile")}
                    name="linkedin_profile"
                    onChange={onChangeLandlord}
                    value={LandlordProfile?.linkedin_profile || ""}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="info-wapper">
                  <label>{_t("email")}</label>
                  <input
                    type="text"
                    className="custom-input"
                    placeholder={_t("enterEmailAddress", "LL edit profile")}
                    name="email"
                    onChange={onChangeLandlord}
                    value={LandlordProfile?.email || ""}
                  />
                </div>
              </div>
            </div>
          </form>
          <div className="row">
            <div>
              <button className="btn-fill2" onClick={onSubmitLandlord}>
                {_t("save")}
              </button>
              <button
                className="btn-fill-border"
                onClick={closeButton}
                style={{ "margin-right": "15px" }}
              >
                {_t("close")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLandLord;
